import { render, staticRenderFns } from "./TagsFieldtype.vue?vue&type=template&id=0c9930e7&"
import script from "./TagsFieldtype.vue?vue&type=script&lang=js&"
export * from "./TagsFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports